import React from "react";

/**
 * Renders the improvement plan. Only headings, bold, numbered and bulleted lines
 * ever appear, so they become elements directly (same approach as the Cyber
 * analyzer's briefing) rather than pulling in a markdown parser.
 */
export default function Narrative({ text }) {
  const bold = (line, key) =>
    String(line).split(/\*\*(.+?)\*\*/g).map((part, i) =>
      i % 2 === 1
        ? <strong key={`${key}-${i}`} style={{ fontWeight: 700, color: "#e8eef5" }}>{part}</strong>
        : <span key={`${key}-${i}`}>{part}</span>);

  return (
    <div style={{ fontSize: 13, lineHeight: 1.65, color: "#c3d2e0" }}>
      {String(text || "").split("\n").map((raw, i) => {
        const line = raw.trim();
        if (!line) return <div key={i} style={{ height: 9 }} />;
        const h = line.match(/^(#{1,4})\s+(.*)$/);
        if (h) {
          const big = h[1].length === 1;
          return (
            <h4 key={i} style={{ fontSize: big ? 15 : 13.5, fontWeight: 700, color: "#e8eef5",
                                 margin: big ? "14px 0 8px" : "16px 0 6px" }}>
              {bold(h[2], i)}
            </h4>
          );
        }
        const numbered = line.match(/^(\d+)[.)]\s+(.*)$/);
        const bullet = /^[-*•]\s+/.test(line);
        if (numbered || bullet) {
          return (
            <div key={i} style={{ display: "flex", gap: 9, margin: "4px 0 4px 4px" }}>
              <span style={{ color: "#6b8aa8", flexShrink: 0, fontWeight: 600,
                             minWidth: numbered ? 16 : 8 }}>
                {numbered ? `${numbered[1]}.` : "•"}
              </span>
              <span>{bold(numbered ? numbered[2] : line.replace(/^[-*•]\s+/, ""), i)}</span>
            </div>
          );
        }
        return <p key={i} style={{ margin: "0 0 4px" }}>{bold(line, i)}</p>;
      })}
    </div>
  );
}
